import { Button, ModalWindow } from '@cian/ui-kit';
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { setCpdCianSource, setCpdSource, setPrelandingModalOpen } from 'shared/actions/cpd';
import { CPDPrelanding, CPDSuccessScreen } from 'shared/components/CPD';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { useCPDProps } from 'shared/containers/CpdPrelandingModal/hooks/useCPDProps';
import { ICPDPrelandingConfig } from 'shared/containers/valuationTraps/HomeownerTrap/CPDHomeownerTrap/types';
import { ECpdDraftStatus, ECpdPrelandingModalView } from 'shared/types/cpd/cpd';

export const CpdPrelandingModal: React.FC = () => {
  const {
    isModalOpen,
    modalView,
    cianSource,
    cpdDraftStatus,
    cpdDraftId,
    offer,
    phoneValue,
    onPhoneInputChange,
    onGoCianChat,
    onCreateDraftCpd,
    isUserAuthorized,
    isMarketingAgreement,
    handleChangeMarketingAgreement,
  } = useCPDProps();

  const dispatch = useDispatch();

  const { config } = useApplicationContext();
  const prelandingContent = config.get<ICPDPrelandingConfig>('CPDPrelandingData');

  const onCloseModal = React.useCallback(() => {
    dispatch(setPrelandingModalOpen({ isOpen: false, modalView: ECpdPrelandingModalView.None }));
    dispatch(setCpdSource(''));
    dispatch(setCpdCianSource(''));
  }, []);

  if (!prelandingContent?.homeowner || modalView === ECpdPrelandingModalView.None) {
    return null;
  }

  if (modalView === ECpdPrelandingModalView.Homeowner) {
    return (
      <ModalWindow
        header={<div />}
        open={isModalOpen}
        onClose={onCloseModal}
        content={
          cpdDraftStatus === ECpdDraftStatus.success ? (
            <CPDSuccessScreen
              cpdDraftId={cpdDraftId}
              successButton={
                <Button onClick={() => onGoCianChat(cpdDraftId)} theme="fill_primary">
                  Подробности — в чате Циан
                </Button>
              }
            />
          ) : (
            <CPDPrelanding
              cpdDraftStatus={cpdDraftStatus}
              onCreateDraftCpd={onCreateDraftCpd}
              prelandingContent={prelandingContent.homeowner}
              isMarketingAgreement={isMarketingAgreement}
              handleChangeMarketingAgreement={handleChangeMarketingAgreement}
              cpdLandingLink={
                prelandingContent.homeowner.secondaryBtn &&
                `${prelandingContent.homeowner.secondaryBtn.url}?cian_source=${cianSource}&offerCategory=${offer.category}`
              }
            />
          )
        }
        size="XS"
        width={540}
      />
    );
  }

  return (
    <ModalWindow
      header={<div />}
      open={isModalOpen}
      onClose={onCloseModal}
      content={
        cpdDraftStatus === ECpdDraftStatus.success ? (
          <CPDSuccessScreen
            cpdDraftId={cpdDraftId}
            successButton={
              isUserAuthorized ? (
                <Button onClick={() => onGoCianChat(cpdDraftId)} theme="fill_primary">
                  Подробности — в чате Циан
                </Button>
              ) : (
                <Button onClick={onCloseModal} theme="fill_primary">
                  Буду ждать
                </Button>
              )
            }
          />
        ) : (
          <CPDPrelanding
            cpdDraftStatus={cpdDraftStatus}
            onCreateDraftCpd={onCreateDraftCpd}
            prelandingContent={prelandingContent.searcher}
            phoneValue={phoneValue}
            onInputChange={onPhoneInputChange}
            withInput
            isMarketingAgreement={isMarketingAgreement}
            handleChangeMarketingAgreement={handleChangeMarketingAgreement}
            cpdLandingLink={
              prelandingContent.searcher.secondaryBtn &&
              `${prelandingContent.searcher.secondaryBtn.url}?cian_source=${cianSource}&offerCategory=${offer.category}`
            }
          />
        )
      }
      size="XS"
      width={540}
    />
  );
};
